module.exports = __webpack_public_path__ + "static/media/sn-3000c.e925a76b.jpg";